import { render, staticRenderFns } from "./CompraProveedores.vue?vue&type=template&id=0b4ec76b&"
import script from "./CompraProveedores.vue?vue&type=script&lang=js&"
export * from "./CompraProveedores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports